import styled from 'styled-components';

import { Country, Postcode } from '@dreryk/address-common-api';
import { NfzDepartment } from '@dreryk/egabinet-nfz-configuration-frontend-api';
import { EmailAddress } from '@dreryk/email-address-common-api';
import { PhoneNumber } from '@dreryk/phone-number-common-api';

import { FormContextValues, useTranslate } from '@dreryk/react-common';

import { patientTranslationKeys } from '../translations';

import { CountryField } from './ContactDetailsForm/CountryField';
import { EmailAddressField } from './ContactDetailsForm/EmailAddressField';
import { NfzDepartmentField } from './ContactDetailsForm/NfzDepartmentField';
import { PhoneNumberField } from './ContactDetailsForm/PhoneNumberField';
import { PostalCodeField } from './ContactDetailsForm/PostalCodeField';
import { FlatField } from './FlatField';
import { FormSectionHeader } from './FormSectionHeader';
import { HouseField } from './HouseField';
import { StreetField } from './StreetField';
import { StyledFormSection } from './StyledFormSection';
import { StyledNarrowInput } from './StyledNarrowInput';
import { TownField } from './TownField';

type ContactDetailsFormBeanPart = {
   country: Country;
   town: string | null;
   postcode: Postcode | null;
   street: string | null;
   house: string | null;
   flat: string | null;
   phoneNumber: PhoneNumber | null;
   emailAddress: EmailAddress | null;
   nfzDepartment: NfzDepartment | null;
};
type ContactDetailsAccordionSectionProps = Pick<FormContextValues<ContactDetailsFormBeanPart>, 'watch' | 'register'>;

const StyledContactDetailsFormSection = styled.div`
   width: 100%;
`;
StyledContactDetailsFormSection.displayName = 'StyledContactDetailsFormSection';

export const ContactDetailsFormSection = (props: ContactDetailsAccordionSectionProps): JSX.Element => {
   const translate = useTranslate();

   return (
      <StyledContactDetailsFormSection>
         <FormSectionHeader>{translate(patientTranslationKeys.addressAndContactDetails)}</FormSectionHeader>
         <StyledFormSection testId={'addressAndContactDetails'}>
            <CountryField register={props.register} />
            <TownField name={'town'} register={props.register} />
            <PostalCodeField register={props.register} watch={props.watch} />
            <StreetField name={'street'} register={props.register} />
            <StyledNarrowInput>
               <HouseField name={'house'} register={props.register} />
            </StyledNarrowInput>
            <StyledNarrowInput>
               <FlatField name={'flat'} register={props.register} />
            </StyledNarrowInput>
            <PhoneNumberField register={props.register} />
            <EmailAddressField register={props.register} />
            <NfzDepartmentField register={props.register} />
         </StyledFormSection>
      </StyledContactDetailsFormSection>
   );
};
